import React, { useState } from 'react';
import { TrendingUpIcon, CalendarIcon, DollarSignIcon, TargetIcon, UsersIcon } from 'lucide-react';
export const SalesPerformance = () => {
  const [viewMode, setViewMode] = useState('weekly');
  return <div className="bg-white rounded-lg shadow-md p-6" data-id="element-2324">
      <div className="flex justify-between items-center mb-6" data-id="element-2325">
        <h2 className="text-lg font-medium text-gray-800" data-id="element-2326">Sales Performance</h2>
        <div className="flex space-x-2" data-id="element-2327">
          <button className={`px-3 py-1 text-sm rounded-md ${viewMode === 'weekly' ? 'bg-teal-100 text-teal-800' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} onClick={() => setViewMode('weekly')} data-id="element-2328">
            Weekly
          </button>
          <button className={`px-3 py-1 text-sm rounded-md ${viewMode === 'monthly' ? 'bg-teal-100 text-teal-800' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} onClick={() => setViewMode('monthly')} data-id="element-2329">
            Monthly
          </button>
        </div>
      </div>
      {/* Sales Metrics Cards */}
      <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-2330">
        {/* Total Sales */}
        <div className="bg-gradient-to-r from-blue-500 to-teal-400 rounded-lg p-4 text-white" data-id="element-2331">
          <div className="flex justify-between items-start" data-id="element-2332">
            <div data-id="element-2333">
              <p className="text-sm font-medium opacity-90" data-id="element-2334">Total Sales</p>
              <p className="text-2xl font-bold mt-1" data-id="element-2335">$24,580</p>
              <div className="flex items-center mt-1" data-id="element-2336">
                <TrendingUpIcon className="h-4 w-4 mr-1" data-id="element-2337" />
                <span className="text-xs" data-id="element-2338">+12% from last week</span>
              </div>
            </div>
            <div className="p-2 bg-white bg-opacity-20 rounded-lg" data-id="element-2339">
              <DollarSignIcon className="h-6 w-6" data-id="element-2340" />
            </div>
          </div>
        </div>
        {/* Target Achievement */}
        <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-2341">
          <div className="flex justify-between items-start" data-id="element-2342">
            <div data-id="element-2343">
              <p className="text-sm font-medium text-gray-500" data-id="element-2344">
                Target Achievement
              </p>
              <p className="text-2xl font-bold text-gray-800 mt-1" data-id="element-2345">78%</p>
              <div className="flex items-center mt-1 text-green-600" data-id="element-2346">
                <TrendingUpIcon className="h-4 w-4 mr-1" data-id="element-2347" />
                <span className="text-xs" data-id="element-2348">+5% from last week</span>
              </div>
            </div>
            <div className="p-2 bg-amber-100 rounded-lg" data-id="element-2349">
              <TargetIcon className="h-6 w-6 text-amber-600" data-id="element-2350" />
            </div>
          </div>
          <div className="mt-3 w-full bg-gray-200 rounded-full h-2" data-id="element-2351">
            <div className="bg-amber-500 h-2 rounded-full" style={{
            width: '78%'
          }} data-id="element-2352"></div>
          </div>
        </div>
        {/* New Customers */}
        <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-2353">
          <div className="flex justify-between items-start" data-id="element-2354">
            <div data-id="element-2355">
              <p className="text-sm font-medium text-gray-500" data-id="element-2356">New Customers</p>
              <p className="text-2xl font-bold text-gray-800 mt-1" data-id="element-2357">12</p>
              <div className="flex items-center mt-1 text-green-600" data-id="element-2358">
                <TrendingUpIcon className="h-4 w-4 mr-1" data-id="element-2359" />
                <span className="text-xs" data-id="element-2360">+2 from last week</span>
              </div>
            </div>
            <div className="p-2 bg-blue-100 rounded-lg" data-id="element-2361">
              <UsersIcon className="h-6 w-6 text-blue-600" data-id="element-2362" />
            </div>
          </div>
        </div>
      </div>
      {/* Sales Trend Chart */}
      <div data-id="element-2363">
        <h3 className="text-sm font-medium text-gray-700 mb-4" data-id="element-2364">Sales Trend</h3>
        <div className="h-64 w-full" data-id="element-2365">
          {/* This would be a real chart in a production app */}
          <div className="h-full w-full bg-gray-50 rounded-lg flex items-end justify-between p-4" data-id="element-2366">
            {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, index) => <div key={index} className="flex flex-col items-center" data-id="element-2367">
                  <div className="w-12 bg-gradient-to-t from-teal-500 to-blue-500 rounded-t-md" style={{
              height: `${Math.floor(Math.random() * 60) + 20}%`
            }} data-id="element-2368"></div>
                  <span className="mt-2 text-xs text-gray-500" data-id="element-2369">{day}</span>
                </div>)}
          </div>
        </div>
      </div>
    </div>;
};